import { CouponsWalletPage } from '@/components/CouponsWalletPage/CouponsWalletPage';
import PageLayout from '@/components/PageLayout';
import User from '@/store/user';
import { getLayoutProps } from '@/utils/layout/layout';
import { useEffect, useState } from 'react';

export default function UserCoupons() {
  const [user, setUser] = useState();

  useEffect(() => {
    const sub = User.subscribe(setUser);

    return () => {
      sub.unsubscribe();
    };
  }, []);

  return <CouponsWalletPage user={user} />;
}

UserCoupons.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'coupons'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale);
  const image = layoutProps?.emptyStates?.cards_empty_state?.url
    ? layoutProps?.emptyStates?.cards_empty_state?.url
    : null;
  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    coupons: (await import(`../../../../prebuild-data/i18n/${locale}/coupons.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
      image,
    },
  };
}
